import { FilterGroup } from "../../../types/filters";
import { feedbackFilterInitialValues } from "../../../init/feedbackFilterInitialValues";
import { emailNotificationFilterInitialValues } from "../../../init/emailNotificationFilterInitialValues";
import { emailTemplateFilterInitialValues } from "../../../init/emailTemplateFilterInitialValues";
import { rolesFilterInitialValues, groupsFilterInitialValues } from "../../../init/groupsAndRolesFiltersInitialValues";
import { usersFilterInitialValues } from "../../../init/usersFilterInitialValues";
import { globalMessageFilterInitialValues } from "../../../init/globalMessageFilterInitialValues";
import { referenceDataFilterInitialValues } from "../../../init/referenceDataFilterInitialValues";
import { nationalUniversityFilterInitialValues } from "../../../init/nationalUniversityFilterInitialValues";

export const SEARCH_FILTERS_GROUP: FilterGroup = {
  FEEDBACK_MANAGEMENT: "sf_feedback_management",
  GLOBAL_MESSAGE_MANAGEMENT: "sf_global_message_management",
  EMAIL_NOTIFICATIONS: "sf_email_notifications",
  EMAIL_TEMPLATES: "sf_email_templates",
  ROLES: "sf_roles_management",
  GROUPS: "sf_groups_management",
  REFERENCE_DATA: "sf_reference_data",
  NATIONAL_UNIVERSITY: "sf_national_university",
};

export const SEARCH_TABLE_CONFIG = {
  [SEARCH_FILTERS_GROUP.FEEDBACK_MANAGEMENT]: {
    initValue: feedbackFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.GLOBAL_MESSAGE_MANAGEMENT]: {
    initValue: globalMessageFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.EMAIL_NOTIFICATIONS]: {
    initValue: emailNotificationFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.EMAIL_TEMPLATES]: {
    initValue: emailTemplateFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.ROLES]: {
    initValue: rolesFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.GROUPS]: {
    initValue: groupsFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.USERS]: {
    initValue: usersFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.REFERENCE_DATA]: {
    initValue: referenceDataFilterInitialValues,
  },
  [SEARCH_FILTERS_GROUP.NATIONAL_UNIVERSITY]: {
    initValue: nationalUniversityFilterInitialValues,
  },
};
